import { useEffect } from 'react';
import { getSocket } from 'src/utils/socket';

export const useSocketEvent = (event, handler, deps = []) => {
  useEffect(() => {
    const socket = getSocket();
    if (!socket) return;

    const attach = () => {
      socket.on(event, handler);
    };

    if (socket.connected) {
      attach();
    } else {
      socket.once('connect', attach);
    }

    return () => {
      socket.off(event, handler);
      socket.off('connect', attach);
    };
  }, [event, handler, ...deps]);
};
